import { D2CSiteContentSlot } from '@orcar/common';
import { useSiteSlot } from '@orcar/common-d2c';
import {
  BUSINESS_PROFILE_FALLBACK,
  CONTACT_PROFILE_FALLBACK,
} from '@/constants/site-content';

export const useBusinessProfile = () =>
  useSiteSlot(D2CSiteContentSlot.BUSINESS_PROFILE, BUSINESS_PROFILE_FALLBACK);

export const useContactProfile = () =>
  useSiteSlot(D2CSiteContentSlot.CONTACT_PROFILE, CONTACT_PROFILE_FALLBACK);
